module.exports = __webpack_public_path__ + "img/lightActive.42216c8c.svg";